import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import pointerDefault from "../../assets/pointer/default";
import proto from "../../assets/pointer/proto";
import pointer1 from "../../assets/pointer/pointer1";
import pointer2 from "../../assets/pointer/pointer2";
import pointer3 from "../../assets/pointer/pointer3";
import coreOnly from "../../assets/pointer/coreOnly";
import { replaceCssVarInvocations } from "../selectors/util/variantStyles";

const pointerVariantAdapter = createEntityAdapter({});

const builtInPointers = {
  default: pointerDefault,
  proto,
  pointer1,
  pointer2,
  pointer3,
  coreOnly,
};

const initialState = pointerVariantAdapter.addMany(
  pointerVariantAdapter.getInitialState({
    currentPointerVariant: "default",
    color0: "#FFFF00FF",
    size: "20px",
  }),
  builtInPointers
);
const sliceName = "pointerVariant";
const pointerVariantSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setCurrentPointerVariant(state, action) {
      state.currentPointerVariant = action.payload;
    },
    setPointerColor0(state, action) {
      state.color0 = action.payload;
    },
    setPointerSize(state, action) {
      state.size = action.payload;
    },
  },
});

export const { setCurrentPointerVariant, setPointerColor0, setPointerSize } =
  pointerVariantSlice.actions;

export default pointerVariantSlice.reducer;

//========== SELECTORS ============
export const getPointerColor0 = (state) => state.color0;
export const getPointerSize = (state) => state.size;

export const globalizedPointerVariantSelectors =
  pointerVariantAdapter.getSelectors((state) => state[sliceName]);

const selectors = pointerVariantAdapter.getSelectors();

export const getPointerVariants = globalizedPointerVariantSelectors.selectIds;

export const getCurrentPointerVariant = (state) => state.currentPointerVariant;

export const getPointerCss = (
  state,
  { variant = state.currentPointerVariant }
) => {
  let pointerCss = selectors.selectById(state, variant)?.css;
  const varExpression = (v) =>
    `--${pointerVariantNameToCssClass(variant)}-${v}`;
  if (pointerCss) {
    const cssVarNameValueObject = {
      [varExpression("color0")]: getPointerColor0(state),
      [varExpression("size")]: getPointerSize(state),
    };
    pointerCss = replaceCssVarInvocations(cssVarNameValueObject, pointerCss);
  }
  return pointerCss;
};

export const getDefaultCoreHtml = (
  state,
  { variant = state.currentPointerVariant }
) => {
  return selectors.selectById(state, variant)?.defaultCore ?? "";
};

// Utils
export const pointerVariantNameToCssClass = (name) =>
  `sirv-pointer-variant-${name}`;
